//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { NsIcon } from "@nuskin/design-components";

export default {
  name: "NsSearchbarTooltip",
  components: { NsIcon },
  props: {
    disabled: Boolean,
    message: {
      type: String,
      default: ""
    }
  }
};
